import React from 'react';
import ReactDOM from 'react-dom';
import LogoFirmaYa  from '../resources/logo_firmaya.png'

export const  MainHeader =()=>{
    return ( 
        <div className="BarHeader">
            <div className="content">
                <div className="col-sm-5">
                    <img src={LogoFirmaYa} />
                </div>                
            </div>
        </div>
       
    )
}
  
export default MainHeader;
   